<template>
  <div>
    <filters-bar
    title="Efectividad"
    title-class="headline"
    :filters="filters"
    :has-channel="true"
    :has-date-type="true"
    @search="setFilters">
    </filters-bar>
    <v-layout row wrap justify-center>
      <template v-for="(info, i) in data">
        <v-flex
          :ml-3="i === 0"
          class="card-pie"
          :key="`card-${i}`"
          pr-3
          @click="showModal(info.title, i)">
          <v-card ripple hover>
            <v-card-title primary-title class="text-xs-center pb-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <p class="subheading">
                    {{ info.title }}
                  </p>
                </v-flex>
                <v-flex xs12>
                  <p class="body-2">
                    {{ new Intl.NumberFormat('es-VE').format(info.total) }}
                  </p>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-layout justify-center>
                <chart
                  width="200px"
                  :graphicData="info.partial" 
                  :legend="false"
                  :labelsInside="true"/>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex :key="`icon-${i}`" v-if="(i + 1) < data.length" class="arrowNext">
          <v-icon>
            fas fa-angle-right
          </v-icon>
        </v-flex>
      </template>
    </v-layout>
    <info-modal :identifier="type" :filters="filters" :titleStatus="name" :show="dialog" @close="dialog = false"/>
  </div>
</template>

<script>
import moment from 'moment';
import Chart from '@/components/global/graphics/Chart';
import FiltersBar from '@/components/global/FiltersBar';
import infoModal from './InfoModal';

export default {
  components: {
    Chart,
    FiltersBar,
    infoModal,
  },
  props: {
    channel: {
      type: Number,
      default: 4,
    },
  },
  created() {
    this.getReport();
  },
  data() {
    return {
      dialog: false,
      name: '',
      type: 0,
      filters: {
        date: moment().format('YYYY-MM-DD'),
        channel: 4,
        dateType: 'date',
      },
      data: [
        {
          title: 'Gestionados',
          total: 0,
          partial: {
            Gestionados: 0,
            'No gestionados': 0,
          },
        },
        {
          title: 'Contactados',
          total: 0,
          partial: {
            Contactados: 0,
            'No contactados': 0,
          },
        },
        {
          title: 'Contacto útil',
          total: 0,
          partial: {
            Contactados: 0,
            'No contactados': 0,
          },
        },
        {
          title: 'Compromiso',
          total: 0,
          partial: {
            'Compromiso de pago': 0,
            'Sin compromiso': 0,
          },
        },
      ],
    };
  },
  methods: {
    showModal(title, id) {
      this.name = title;
      this.type = id;
      this.dialog = true;
    },
    setFilters(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
    },
    getReport() {
      this.axios.get('efectivity/stages/report', {
        params: {
          ...this.filters,
        },
      }).then((res) => {
        this.data[0].total = Number(res.data.totalNs) || 0;
        this.data[0].partial.Gestionados = this.data[0].total;
        this.data[0].partial['No gestionados'] = Math.abs(res.data.allCustomers - this.data[0].total);

        // eslint-disable-next-line
        this.data[1].total = Number(res.data.contacted.contacted) || 0;
        // eslint-disable-next-line
        this.data[1].partial.Contactados = this.data[1].total || 0;
        // eslint-disable-next-line
        this.data[1].partial['No contactados'] = this.data[0].total - this.data[1].total;

        // eslint-disable-next-line
        this.data[2].total = Number(res.data.contacted.reached) || 0;
        // eslint-disable-next-line
        this.data[2].partial.Contactados = this.data[2].total || 0;
        // eslint-disable-next-line
        this.data[2].partial['No contactados'] =  this.data[1].total - this.data[2].total;

        // eslint-disable-next-line
        this.data[3].total = Number(res.data.contacted.promise) || 0;
        // eslint-disable-next-line
        this.data[3].partial['Compromiso de pago'] = this.data[3].total || 0;
        // eslint-disable-next-line
        this.data[3].partial['Sin compromiso'] =  this.data[2].total - this.data[3].total;
      });
    },
  },
  watch: {
    filters() { // eslint-disable-line
      this.getReport();
    },
  },
};
</script>
<style scoped>
  .arrowNext {
    margin-top: auto;
    margin-bottom: auto;
  }
  .card-pie{
    -ms-flex-preferred-size: 22%;
    flex-basis: 22%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 22%;
  }
</style>




// WEBPACK FOOTER //
// src/components/panel/efectivity/EfectivityGraphics.vue